import {
    signInWithPopup,
    GoogleAuthProvider,
    FacebookAuthProvider,
    signOut,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "./config";
import { Store, STORES } from "./store";
import { AuthData, LoginInput, RegisterInput } from "./types";
import { getProfile, saveUser } from "./users";

const google_provider = new GoogleAuthProvider();
const facebook_provider = new FacebookAuthProvider();

class Auth {
    static async signInWithGoogle() {
        try {
            const result = await signInWithPopup(auth, google_provider);
            const user = result.user;

            const userdata = await saveUser(user);

            return userdata;
        } catch (error: any) {
            throw error;
        }
    }

    static async signInWithFacebook() {
        try {
            const result = await signInWithPopup(auth, facebook_provider);
            const user = result.user;

            const userdata = await saveUser(user);

            return userdata;
        } catch (error: any) {
            throw error;
        }
    }

    static async getIdToken() {
        try {
            const token = await auth?.currentUser?.getIdToken(true);
            return token;
        } catch (error) {
            return null;
        }
    }

    static async signUpWithEmailAndPassword(userData: RegisterInput) {
        try {
            const result = await createUserWithEmailAndPassword(auth, userData.email, userData.password);

            const user = result.user;

            // user.
            const userdata = await saveUser({ ...user, company: userData.company, displayName: userData.name });

            return userdata;
        } catch (error) {
            throw error;
        }
    }

    static async loginWithEmailAndPassword(userData: LoginInput) {
        try {
            const result = await signInWithEmailAndPassword(auth, userData.email, userData.password);

            return getProfile(result?.user?.uid);
        } catch (error) {
            throw error;
        }
    }

    static async updateProfile(userId: string, data: AuthData) {
        try {
            await Store.update(STORES.USERS, userId, data);

            return data;
        } catch (error) {
            throw error;
        }
    }

    static async signOut() {
        try {
            await signOut(auth);
        } catch (error) {
            console.log(error);
            throw error;
        }
    }
}

export { Auth };
